// My-Components
import Contact from "../Components/Contact";
import Works from "../Components/home/Works";
import Landing from "../Components/home/Landing";
import Services from "../Components/home/Services";

const Home = () => {
   // ################### Global Data ###################
   document.title = "ماتريكس | الصفحة الرئيسية";

   return (
      <main style={{ direction: "rtl" }}>
         <Landing />
         <Services />
         <Works />
         <Contact />
      </main>
   );
};

export default Home;
